module.exports = __webpack_public_path__ + "img/bars.d3efc70e.svg";